import { Column, FMColumn } from '../model';
import { Type } from '../../../../general/modules/filter/dataModel';
import { FilterDateContainer } from '../components/plugins/filters/FilterDateContainer';
import { DateCell } from '../components/cells/DateCell';

export const createdCol: FMColumn<Type.DATE> = {
  key: Column.created_at,
  dataKey: Column.created_at,
  title: 'Created at',
  // Было 120: индикатор сортировки, который теперь рисует сама таблица,
  // переносил заголовок на две строки.
  width: 135,
  sortable: true,
  cellRenderer: DateCell,
  className: 'ch-file-manager__cell_created_at',
  filter: Type.DATE,
  plugins: [FilterDateContainer],
  getter: (row) => new Date(row.created_at),
  toDisplayString: (row) => new Date(row.created_at).toDateString(),
};
